import React, { useState, useRef } from 'react';
import { IconButton, Collapse, Box, Tooltip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Visibility from '@mui/icons-material/Visibility';
import LogoCarousel from './LogoCarousel';
import { LOGHI_ECOSISTER } from 'constants/loghiPartner';
import { useTranslation } from 'react-i18next';

export default function Footer() {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const wrapperRef = useRef(null);
    return (
        <React.Fragment>
            {!open && (
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'left',
                    mt: 3,
                }}>
                    <Tooltip title={t('showFooter')}>
                        <IconButton
                            onClick={() => setOpen(true)}
                            sx={{
                                bgcolor: 'primary.main',
                                color: 'common.white',
                                boxShadow: 3,
                                '&:hover': { bgcolor: 'primary.dark' },
                            }}
                        >
                            <Visibility />
                        </IconButton>
                    </Tooltip>
                </Box>
            )}
            <Collapse in={open} onEntered={() => {
                wrapperRef.current?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'end',
                });
            }}>
                <Box ref={wrapperRef} sx={{ position: 'relative', mt: 5 }}>
                    <IconButton
                        onClick={() => setOpen(false)}
                        size="small"
                        sx={{
                            position: 'absolute',
                            top: 8,
                            left: 8,
                            bgcolor: 'background.paper',
                            border: '1px solid',
                            borderColor: 'divider',
                            zIndex: 1,
                            '&:hover': { bgcolor: 'grey.100' },
                        }}
                    >
                        <CloseIcon fontSize="small" />
                    </IconButton>
                    <LogoCarousel loghi={LOGHI_ECOSISTER}/>
                </Box>
            </Collapse>
        </React.Fragment>
    );
}
